/**
 * Tour steps for the Clients page.
 *
 * @param {Function} t - The i18next translation function.
 * @returns {import('react-joyride').Step[]}
 */
export const getClientsPageSteps = (t) => [
    {
        target: 'body',
        placement: 'center',
        title: t('tour.clients.step-welcome-title'),
        content: t('tour.clients.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cl-header"]',
        title: t('tour.clients.step-header-title'),
        content: t('tour.clients.step-header-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cl-filters"]',
        title: t('tour.clients.step-filters-title'),
        content: t('tour.clients.step-filters-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cl-content"]',
        title: t('tour.clients.step-list-title'),
        content: t('tour.clients.step-list-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cl-footer"]',
        title: t('tour.clients.step-pagination-title'),
        content: t('tour.clients.step-pagination-content'),
        disableBeacon: true,
    },
];
